// extracted by mini-css-extract-plugin
export default {"toggle":"RailThemeToggle_toggle__bG-3p"};